module.exports = __webpack_public_path__ + "media/images/emoticons/soon-2f1aa94b8a833aa02f90985f2faa7cae.gif";